import http from "./http";
export const baseUrl = "/v1/api/app";
export const baseUrl2 = "/v2/api/system";
export const baseUrl3 = "/v1/api/system";
export const uploadDemoBaseUrl = "https://developer-upload.kaihong.com/v1/api/app";
const hostname = window.location.hostname;
const isDeveloper = hostname === "work.kaihong.com";
// export const uploadBaseUrl = isDeveloper ? uploadDemoBaseUrl : baseUrl;
export const uploadBaseUrl = baseUrl;

const { get, post } = http;
const getAtomicDetail = (params: any) => post(`${baseUrl}/atomic/detail`, params); // 查询原子化详情
const getAppDetail = (params: any) => post(`${baseUrl}/app/detail`, params); // 查询应用详情
const getEngineDetail = (params: any) => post(`${baseUrl}/engine/detail`, params); // 查询开鸿应用引擎详情
const getAcsDetail = (params: any) => post(`${baseUrl}/acs/detail`, params); // 查询安卓生态应用详情
const getComponentDetail = (params: any) => post(`${baseUrl}/component/detail`, params); // 查询组件详情
const getKcsDetail = (params: any) => post(`${baseUrl}/kcs/detail`, params); // 查询Linux应用详情
const getPsoDetail = (params: any) => post(`${baseUrl}/pso/detail`, params); // 查询IDE插件应用详情
const getToolBoxDetail = (params: any) => post(`${baseUrl}/toolbox/detail`, params); // 查询工具应用详情
const atomicSave = (params: any) => post(`${baseUrl}/atomic/save`, params); // 保存原子化全部信息
const appSave = (params: any) => post(`${baseUrl}/app/save`, params); // 保存应用全部信息
const engineSave = (params: any) => post(`${baseUrl}/engine/save`, params); // 保存开鸿应用引擎全部信息
const acsSave = (params: any) => post(`${baseUrl}/acs/save`, params); // 保存安卓生态应用全部信息
const componentSave = (params: any) => post(`${baseUrl}/component/save`, params); // 保存组件全部信息
const kcsSave = (params: any) => post(`${baseUrl}/kcs/save`, params); // 保存Linux应用全部信息
const psoSave = (params: any) => post(`${baseUrl}/pso/save`, params); // 保存IDE插件应用全部信息
const toolboxSave = (params: any) => post(`${baseUrl}/toolbox/save`, params); // 保存工具应用全部信息
const atomicDelete = (params: any) => post(`${baseUrl}/atomic/delete`, params); //删除原子化服务
const appDelete = (params: any) => post(`${baseUrl}/app/delete`, params); //删除应用
const engineDelete = (params: any) => post(`${baseUrl}/engine/delete`, params); //删除开鸿应用引擎
const acsDelete = (params: any) => post(`${baseUrl}/acs/delete`, params); //删除安卓生态应用
const componentDelete = (params: any) => post(`${baseUrl}/component/delete`, params); //删除组件
const kcsDelete = (params: any) => post(`${baseUrl}/kcs/delete`, params); //删除Linux应用
const psoDelete = (params: any) => post(`${baseUrl}/pso/delete`, params); //删除IDE插件应用
const toolboxDelete = (params: any) => post(`${baseUrl}/toolbox/delete`, params); //删除工具应用
const atomicAuditRelease = (params: any) => post(`${baseUrl}/atomic/audit/release`, params); //原子化审核上架
const appAuditRelease = (params: any) => post(`${baseUrl}/app/audit/release`, params); //应用审核上架
const engineAuditRelease = (params: any) => post(`${baseUrl}/engine/audit/release`, params); //开鸿应用引擎审核上架
const acsAuditRelease = (params: any) => post(`${baseUrl}/acs/audit/release`, params); //安卓生态应用审核上架
const componentAuditRelease = (params: any) => post(`${baseUrl}/component/audit/release`, params); //组件审核上架
const kcsAuditRelease = (params: any) => post(`${baseUrl}/kcs/audit/release`, params); //Linux应用审核上架
const psoAuditRelease = (params: any) => post(`${baseUrl}/pso/audit/release`, params); //IDE插件应用审核上架
const toolboxAuditRelease = (params: any) => post(`${baseUrl}/toolbox/audit/release`, params); //工具应用审核上架
const atomicNextSave = (params: any) => post(`${baseUrl}/atomic/next/save`, params); //原子化保存全部信息并且下一步
const appNextSave = (params: any) => post(`${baseUrl}/app/next/save`, params); //应用保存全部信息并且下一步
const engineNextSave = (params: any) => post(`${baseUrl}/engine/next/save`, params); //开鸿应用引擎保存全部信息并且下一步
const acsNextSave = (params: any) => post(`${baseUrl}/acs/next/save`, params); //安卓生态应用保存全部信息并且下一步
const componentNextSave = (params: any) => post(`${baseUrl}/component/next/save`, params); //组件保存全部信息并且下一步
const kcsNextSave = (params: any) => post(`${baseUrl}/kcs/next/save`, params); //Linux应用保存全部信息并且下一步
const psoNextSave = (params: any) => post(`${baseUrl}/pso/next/save`, params); //IDE插件保存全部信息并且下一步
const toolboxNextSave = (params: any) => post(`${baseUrl}/toolbox/next/save`, params); //工具保存全部信息并且下一步
const atomicCancelRelease = (params: any) => post(`${baseUrl}/atomic/cancel/release`, params); //原子化撤销上架
const appCancelRelease = (params: any) => post(`${baseUrl}/app/cancel/release`, params); //应用撤销上架
const engineCancelRelease = (params: any) => post(`${baseUrl}/engine/cancel/release`, params); //开鸿应用引擎撤销上架
const acsCancelRelease = (params: any) => post(`${baseUrl}/acs/cancel/release`, params); //安卓生态应用撤销上架
const componentCancelRelease = (params: any) => post(`${baseUrl}/component/cancel/release`, params); //组件撤销上架
const kcsCancelRelease = (params: any) => post(`${baseUrl}/kcs/cancel/release`, params); //Linux应用撤销上架
const psoCancelRelease = (params: any) => post(`${baseUrl}/pso/cancel/release`, params); //IDE插件应用撤销上架
const toolboxCancelRelease = (params: any) => post(`${baseUrl}/toolbox/cancel/release`, params); //工具应用撤销上架
const atomicAuditDown = (params: any) => post(`${baseUrl}/atomic/audit/down`, params); //原子化审核下架
const appAuditDown = (params: any) => post(`${baseUrl}/app/audit/down`, params); //应用审核下架
const engineAuditDown = (params: any) => post(`${baseUrl}/engine/audit/down`, params); //开鸿应用引擎审核下架
const acsAuditDown = (params: any) => post(`${baseUrl}/acs/audit/down`, params); //安卓生态应用审核下架
const componentAuditDown = (params: any) => post(`${baseUrl}/component/audit/down`, params); //组件审核下架
const kcsAuditDown = (params: any) => post(`${baseUrl}/kcs/audit/down`, params); //Linux应用审核下架
const psoAuditDown = (params: any) => post(`${baseUrl}/pso/audit/down`, params); //Linux应用审核下架
const toolboxAuditDown = (params: any) => post(`${baseUrl}/toolbox/audit/down`, params); //Linux应用审核下架
const atomicCancelDown = (params: any) => post(`${baseUrl}/atomic/cancel/down`, params); //原子化撤销下架
const appCancelDown = (params: any) => post(`${baseUrl}/app/cancel/down`, params); //应用撤销下架
const engineCancelDown = (params: any) => post(`${baseUrl}/engine/cancel/down`, params); //开鸿应用引擎撤销下架
const acsCancelDown = (params: any) => post(`${baseUrl}/acs/cancel/down`, params); //安卓生态应用撤销下架
const componentCancelDown = (params: any) => post(`${baseUrl}/component/cancel/down`, params); //组件撤销下架
const kcsCancelDown = (params: any) => post(`${baseUrl}/kcs/cancel/down`, params); //Linux应用撤销下架
const psoCancelDown = (params: any) => post(`${baseUrl}/pso/cancel/down`, params); //IDE插件应用撤销下架
const toolboxCancelDown = (params: any) => post(`${baseUrl}/toolbox/cancel/down`, params); //工具应用撤销下架
const atomicUpgrade = (params: any) => post(`${baseUrl}/atomic/version/upgrade`, params); //原子化服务升级
const appUpgrade = (params: any) => post(`${baseUrl}/app/version/upgrade`, params); //应用服务升级
const engineUpgrade = (params: any) => post(`${baseUrl}/engine/version/upgrade`, params); //开鸿应用引擎服务升级
const acsUpgrade = (params: any) => post(`${baseUrl}/acs/version/upgrade`, params); //安卓生态应用服务升级
const componentUpgrade = (params: any) => post(`${baseUrl}/component/version/upgrade`, params); //组件服务升级
const kcsUpgrade = (params: any) => post(`${baseUrl}/kcs/version/upgrade`, params); //Linux应用服务升级
const psoUpgrade = (params: any) => post(`${baseUrl}/pso/version/upgrade`, params); //IDE插件应用服务升级
const toolboxUpgrade = (params: any) => post(`${baseUrl}/toolbox/version/upgrade`, params); //工具应用服务升级
const atomicAuditUpgrade = (params: any) => post(`${baseUrl}/atomic/audit/upgrade`, params); //原子化审核升级
const appAuditUpgrade = (params: any) => post(`${baseUrl}/app/audit/upgrade`, params); //应用审核升级
const engineAuditUpgrade = (params: any) => post(`${baseUrl}/engine/audit/upgrade`, params); //开鸿应用引擎审核升级
const acsAuditUpgrade = (params: any) => post(`${baseUrl}/acs/audit/upgrade`, params); //安卓生态应用审核升级
const componentAuditUpgrade = (params: any) => post(`${baseUrl}/component/audit/upgrade`, params); //组件审核升级
const kcsAuditUpgrade = (params: any) => post(`${baseUrl}/kcs/audit/upgrade`, params); //Linux应用审核升级
const psoAuditUpgrade = (params: any) => post(`${baseUrl}/pso/audit/upgrade`, params); //IDE插件应用审核升级
const toolboxAuditUpgrade = (params: any) => post(`${baseUrl}/toolbox/audit/upgrade`, params); //工具应用审核升级
const atomicCancelUpgrade = (params: any) => post(`${baseUrl}/atomic/cancel/upgrade`, params); //原子化撤销升级
const appCancelUpgrade = (params: any) => post(`${baseUrl}/app/cancel/upgrade`, params); //应用撤销升级
const engineCancelUpgrade = (params: any) => post(`${baseUrl}/engine/cancel/upgrade`, params); //开鸿应用引擎撤销升级
const acsCancelUpgrade = (params: any) => post(`${baseUrl}/acs/cancel/upgrade`, params); //安卓生态应用撤销升级
const componentCancelUpgrade = (params: any) => post(`${baseUrl}/component/cancel/upgrade`, params); //组件撤销升级
const kcsCancelUpgrade = (params: any) => post(`${baseUrl}/kcs/cancel/upgrade`, params); //Linux应用撤销升级
const psoCancelUpgrade = (params: any) => post(`${baseUrl}/pso/cancel/upgrade`, params); //IDE插件应用撤销升级
const toolboxCancelUpgrade = (params: any) => post(`${baseUrl}/toolbox/cancel/upgrade`, params); //工具应用撤销升级

const componentOs = (params?: any) => post(`${baseUrl}/component/os/page`, params); //查询OS的兼容版本列表

const uploadFile = (params: any, id: any, config?: any) =>
  post(`${uploadBaseUrl}/app/upload/public/${id}`, params, config); //上传

const getDict = (params: any) => get(`${baseUrl2}/dict/data/type/${params}`); // 获取字典

const getAllTypes = () => get(`${baseUrl}/app/types`); // 应用类型列表查询

const getDomianTypes = (params: any) => post(`${baseUrl}/app/domain-topic/list`, params); // 获取字典

// 自定义类型相关通用接口
const reqAppDetail = (params: any) => post(`${baseUrl}/custom/app/detail`, params); // 应用详情
const reqAppDel = (params: any) => post(`${baseUrl}/custom/app/delete`, params); // 删除应用
const reqAppAuditDown = (params: any) => post(`${baseUrl}/custom/app/audit/down`, params); // 应用审核下架
const reqAppSave = (params: any) => post(`${baseUrl}/custom/app/save`, params); // 保存应用全部信息
const reqAppCancelDown = (params: any) => post(`${baseUrl}/custom/app/cancel/down`, params); // 应用撤销下架reqAppUpgrade
const reqAppUpgrade = (params: any) => post(`${baseUrl}/custom/app/version/upgrade`, params); // 应用服务升级
const reqAppNextSave = (params: any) => post(`${baseUrl}/custom/app/next/save`, params); //IDE插件保存全部信息并且下一步
const reqAppAuditRelease = (params: any) => post(`${baseUrl}/custom/app/audit/release`, params); //IDE插件应用审核上架
const reqAppAuditUpgrade = (params: any) => post(`${baseUrl}/custom/app/audit/upgrade`, params); //pso应用审核升级
const reqAppCancelRelease = (params: any) => post(`${baseUrl}/custom/app/cancel/release`, params); //IDE插件应用撤销上架
const reqAppCancelUpgrade = (params: any) => post(`${baseUrl}/custom/app/cancel/upgrade`, params); //IDE插件应用撤销升级

//查询数据字典的type为DOMAIN、TOPIC、AI_MODEL_INDUSTRY、SUPPORT_CHIP、RULE_ENGINE_INDUSTRY、SUPPORT_PROTOCOL
const getNewDict = (type: string) => get(`${baseUrl3}/dict/data/type/tenant/DEVELOPER/${type}`);

export default {
  getAtomicDetail,
  getAppDetail,
  getEngineDetail,
  getAcsDetail,
  getComponentDetail,
  getKcsDetail,
  getPsoDetail,
  getToolBoxDetail,
  getDict,
  atomicSave,
  appSave,
  engineSave,
  acsSave,
  componentSave,
  kcsSave,
  psoSave,
  toolboxSave,
  atomicDelete,
  appDelete,
  engineDelete,
  acsDelete,
  componentDelete,
  kcsDelete,
  psoDelete,
  toolboxDelete,
  atomicAuditRelease,
  appAuditRelease,
  engineAuditRelease,
  acsAuditRelease,
  componentAuditRelease,
  kcsAuditRelease,
  psoAuditRelease,
  toolboxAuditRelease,
  uploadFile,
  atomicNextSave,
  appNextSave,
  engineNextSave,
  acsNextSave,
  componentNextSave,
  kcsNextSave,
  psoNextSave,
  toolboxNextSave,
  atomicCancelRelease,
  appCancelRelease,
  engineCancelRelease,
  acsCancelRelease,
  componentCancelRelease,
  kcsCancelRelease,
  psoCancelRelease,
  toolboxCancelRelease,
  atomicAuditDown,
  appAuditDown,
  engineAuditDown,
  acsAuditDown,
  componentAuditDown,
  kcsAuditDown,
  psoAuditDown,
  toolboxAuditDown,
  atomicCancelDown,
  appCancelDown,
  engineCancelDown,
  acsCancelDown,
  componentCancelDown,
  kcsCancelDown,
  psoCancelDown,
  toolboxCancelDown,
  atomicUpgrade,
  appUpgrade,
  engineUpgrade,
  acsUpgrade,
  componentUpgrade,
  kcsUpgrade,
  psoUpgrade,
  toolboxUpgrade,
  atomicAuditUpgrade,
  appAuditUpgrade,
  engineAuditUpgrade,
  acsAuditUpgrade,
  componentAuditUpgrade,
  kcsAuditUpgrade,
  psoAuditUpgrade,
  toolboxAuditUpgrade,
  atomicCancelUpgrade,
  appCancelUpgrade,
  engineCancelUpgrade,
  acsCancelUpgrade,
  componentCancelUpgrade,
  kcsCancelUpgrade,
  psoCancelUpgrade,
  toolboxCancelUpgrade,
  componentOs,
  getAllTypes,
  getDomianTypes,
  reqAppDetail,
  reqAppDel,
  reqAppAuditDown,
  reqAppSave,
  reqAppCancelDown,
  reqAppUpgrade,
  reqAppNextSave,
  reqAppAuditRelease,
  reqAppAuditUpgrade,
  reqAppCancelRelease,
  reqAppCancelUpgrade,
  getNewDict,
};
